import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const templateMessageWhatsappRoutes = [
	{
		component: LazyComponent(lazy(() => import('./Update'))),
		path: '/templateWhatsApp/update/:id',
	},
	{
		component: LazyComponent(lazy(() => import('./Create'))),
		path: '/templateWhatsApp/create',
	},
];

export default templateMessageWhatsappRoutes;
